<script setup>
/* eslint-disable */
import { ref, inject, watch } from 'vue'
import CryptoJS from 'crypto-js'
import UsuarioService from '@/services/seguranca/usuario-service'
import BaseButton from '@/components/base/BaseButton.vue'
import Snackbar from '@/components/base/Snackbar.vue'

const endpoint = inject('endpoint')
const headerPadrao = inject('headerPadrao')
const chaveSeguranca = inject('chaveSeguranca')
const usuarioSeguranca = inject('usuarioSeguranca')

const usuarioService = new UsuarioService(endpoint, headerPadrao, chaveSeguranca, usuarioSeguranca)

const props = defineProps({
  /** Controlado pelo pai: true abre o modal */
  modelValue: { type: Boolean, required: true },
})
const emits = defineEmits(['update:modelValue'])

const form = ref(null)
const senhaNova = ref('')
const senhaConfirmacao = ref('')
const loading = ref(false)
const retorno = ref(false)
const sucesso = ref(false)
const mensagemRetorno = ref('')

function getUsuarioId() {
  try {
    const enc = localStorage.getItem('loginNovoSanegeo')
    if (!enc || !chaveSeguranca) return null
    const bytes = CryptoJS.AES.decrypt(enc, chaveSeguranca)
    const json = bytes.toString(CryptoJS.enc.Utf8)
    if (!json) return null
    return JSON.parse(json)?.data?.usuario?.usuarioId ?? null
  } catch {
    return null
  }
}

const rules = {
  required: v => !!v || 'Campo obrigatório',
  minLength: v => (v && v.length >= 4) || 'Senha deve ter pelo menos 4 caracteres',
  matchPassword: v => v === senhaNova.value || 'As senhas não coincidem',
}

watch(() => props.modelValue, (aberto) => {
  if (aberto) {
    senhaNova.value = ''
    senhaConfirmacao.value = ''
    form.value?.resetValidation()
  }
})

async function submitSenha() {
  if (!form.value) return

  const result = await form.value.validate()
  const valid = typeof result === 'boolean' ? result : result?.valid

  if (!valid) {
    sucesso.value = false
    mensagemRetorno.value = 'Corrija os erros antes de salvar.'
    retorno.value = true
    return
  }

  const usuarioId = getUsuarioId()
  if (!usuarioId) {
    sucesso.value = false
    mensagemRetorno.value = 'Não foi possível identificar o usuário. Faça login novamente.'
    retorno.value = true
    return
  }

  loading.value = true
  try {
    const resposta = await usuarioService.alterarSenha(
      usuarioId,
      senhaNova.value,
      senhaConfirmacao.value,
    )

    if (resposta?.statusCode === 200) {
      sucesso.value = true
      mensagemRetorno.value = resposta?.data?.message || 'Senha alterada com sucesso!'
      retorno.value = true

      setTimeout(() => {
        emits('update:modelValue', false)
      }, 1800)
    } else {
      sucesso.value = false
      mensagemRetorno.value = resposta?.data?.message || 'Erro ao alterar a senha.'
      retorno.value = true
    }
  } catch {
    sucesso.value = false
    mensagemRetorno.value = 'Erro ao alterar a senha. Contacte o Administrador.'
    retorno.value = true
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <v-dialog :model-value="modelValue" class="form-dialog" max-width="500" persistent no-click-animation>
    <v-card>
      <v-card-text class="pa-4">

        <div class="d-flex align-center pb-2">
          <font-awesome-icon icon="lock" class="text-primary me-2" />
          <span class="title black--text">Troca de Senha Obrigatória</span>
        </div>

        <v-divider class="pb-3" />

        <v-alert type="info" variant="tonal" density="compact" class="mb-4" icon="false">
          <template #prepend>
            <font-awesome-icon icon="circle-info" class="me-2" />
          </template>
          Este é seu primeiro acesso. Defina uma nova senha para continuar.
        </v-alert>

        <v-form ref="form" @submit.prevent="submitSenha">
          <v-container class="pa-3 pt-0 container-modal">
            <v-row>
              <v-col cols="12" class="pa-0 pb-4">
                <v-text-field v-model="senhaNova" label="Nova Senha" type="password" clearable density="compact"
                  hide-details="auto" variant="outlined" color="grey-darken-1" base-color="grey-darken-1"
                  :rules="[rules.required, rules.minLength]" />
              </v-col>

              <v-col cols="12" class="pa-0 pb-2">
                <v-text-field v-model="senhaConfirmacao" label="Confirmar Nova Senha" type="password" clearable
                  density="compact" hide-details="auto" variant="outlined" color="grey-darken-1"
                  base-color="grey-darken-1" :rules="[rules.required, rules.matchPassword]" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <small class="label-italic">Senha deve ter no mínimo 4 caracteres.</small>

      </v-card-text>

      <v-card-actions class="pt-0 pb-4 px-4">
        <v-spacer />
        <BaseButton label="Salvar" type="save" iconPosition="left" :disabled="loading" @click="submitSenha" />
      </v-card-actions>
    </v-card>
  </v-dialog>

  <Snackbar :retorno="retorno" :timeout="3000" :tipo="sucesso ? 'sucesso' : 'erro'" :mensagemRetorno="mensagemRetorno"
    @ocultarRetorno="() => { retorno = false }" />
</template>

<style scoped>
.label-italic {
  font-style: italic;
}
</style>